import { Component, inject } from '@angular/core';
import {
  ModalService,
  ModalRef,
  WithOnDestroy,
  ModalModule,
  TileV2Module,
  ButtonV2Module,
} from '@schenck/rotec-components';
import { UpsertMachineTaskWizardComponent } from '../upsert-machine-task-wizard/upsert-machine-task-wizard.component';
import { MachineTaskService } from 'src/services';
import { UploadTasksModalComponent } from 'src/components';
import { takeUntil } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';

export enum CreateTaskResponse {
  CreatedTask = 'CreatedTask',
  UploadedTaskList = 'UploadedTaskList',
}

@Component({
  selector: 'ma-choose-machine-task-option-modal',
  templateUrl: './choose-machine-task-option-modal.component.html',
  styleUrls: ['./choose-machine-task-option-modal.component.less'],
  imports: [ModalModule, TileV2Module, ButtonV2Module, TranslatePipe],
})
export class ChooseMachineTaskOptionModalComponent extends WithOnDestroy {
  private readonly modalService = inject(ModalService);
  private readonly taskService = inject(MachineTaskService);
  private readonly modalRef = inject<ModalRef<void, CreateTaskResponse>>(ModalRef);

  constructor() {
    super();
  }

  close() {
    this.modalRef.close();
  }

  createNewTask() {
    this.modalService
      .open(UpsertMachineTaskWizardComponent)
      .events$.pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        // if we get in here we know it worked
        this.modalRef.emitAndClose(CreateTaskResponse.CreatedTask);
      });
  }

  uploadTaskList() {
    this.modalService
      .open(UploadTasksModalComponent, this.taskService)
      .events$.pipe(takeUntil(this.onDestroy$))
      .subscribe(() => this.modalRef.emitAndClose(CreateTaskResponse.UploadedTaskList));
  }
}
